(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-video"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var video = document.getElementById('myVideo');
    if (video) {
      video.play().catch(function(error) {
        console.log('Auto-play was prevented:', error);
      });

      // Ensure video is visible
      video.style.display = 'block';

      // Log video properties for debugging
      console.log('Video properties:', {
        src: video.currentSrc,
        readyState: video.readyState,
        networkState: video.networkState,
        error: video.error
      });
    } else {
      console.log('Video element not found');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-carousel"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.carousel').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      draggable: true,
      arrows: false,  // This line hides the navigation arrows
      dots: false,  // This line hides the dots
      autoplaySpeed: 0,
      pauseOnHover: true,
      speed: 5000,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-product-slider"] && !window.DesignMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function() {
    const track = document.querySelector('.ss_product-track');
    const slides = track.querySelectorAll('.ss_product-slide');
    const slideWidth = slides[0].offsetWidth;
    const totalWidth = slideWidth * slides.length;
    
    // Clone slides and append to create seamless loop
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      track.appendChild(clone);
    });

    track.style.width = `${totalWidth * 2}px`;

    let position = 0;
    const speed = 2.5; // Adjust this value to change the sliding speed

    function animate() {
      position -= speed;
      if (position <= -totalWidth) {
        position = 0;
        track.style.transition = 'none';
        track.style.transform = `translateX(${position}px)`;
        track.offsetHeight; // Force reflow
        track.style.transition = 'transform 0s linear';
      }
      track.style.transform = `translateX(${position}px)`;
      requestAnimationFrame(animate);
    }

    let isAnimating = true;
    animate();

    // Pause animation on hover
    track.addEventListener('mouseenter', () => {
      isAnimating = false;
    });

    track.addEventListener('mouseleave', () => {
      isAnimating = true;
      animate();
    });

    function animate() {
      if (!isAnimating) return;
      position -= speed;
      if (position <= -totalWidth) {
        position = 0;
        track.style.transition = 'none';
        track.style.transform = `translateX(${position}px)`;
        track.offsetHeight; // Force reflow
        track.style.transition = 'transform 0s linear';
      }
      track.style.transform = `translateX(${position}px)`;
      requestAnimationFrame(animate);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["johndoe-title"] && !window.DesignMode) return;
  try {
    
  // Any component-specific JavaScript can go here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-page-selector"]) return;
  try {
    
  function updateMexicoCityTime() {
    const now = new Date();
    const options = { hour: '2-digit', minute: '2-digit', hour12: false };
    const mexicoCityTime = now.toLocaleTimeString('en-US', { timeZone: 'America/Mexico_City', ...options });
    document.getElementById('mexico-city-clock').innerHTML = mexicoCityTime;
  }

  updateMexicoCityTime();
  setInterval(updateMexicoCityTime, 1000);

  } catch(e) { console.error(e); }
})();
})();
